/**
 * Message FR pour les menus
 */

module.exports = {

    // Menu latéral
    side: {

        home: {
            label: 'Dashboard',
            altLabel: 'Retourner au tableau de bord.'
        },

        superAdmin: {
            label: 'Paramètres de l\'application (Super Admin)',
            altLabel: 'Consulter les paramètres de l\'application Super Admin.'
        },

        me: {
            account: {
                label: 'Mon compte',
                altLabel: 'Consulter les paramètres de votre compte.'
            },
            requestedHolidays: {
                internal: {
                    label: 'Demande de congés',
                    altLabel: 'Consulter vos demandes de congés.'
                },
                external: {
                    label: 'Demande d\'absences',
                    altLabel: 'Consulter vos demandes d\'absences.'
                }
            },
            task: {
                managing: {
                    label: 'Tâches',
                    altLabel: 'Consulter les tâches affectées à vos agents'
                },
                running: {
                    label: 'Tâches',
                    altLabel: 'Consulter les tâches qui vous sont affectées.'
                },
                list: {
                    label: 'Publications',
                    altLabel: 'Consulter la liste des publications.'
                },
                write: {
                    label: 'Ajouter un post',
                    altLabel: 'Démarrer la rédaction d\'une tâche.'
                }
            },

        },

        admin: {
            credits: {
                label: 'Administration des crédits',
                altLabel: 'Gérer les tarifs des tâches, des crédits et des abonnements.'
            },
            videos: {
                label: 'Administration des vidéos',
                altLabel: 'Gérer les vidéos proposées pour une publication.',
                tutorial: {
                    label: 'Tutoriels vidéos',
                    altLabel: 'Gérer les vidéos de tutorial.',
                }
            },
            publicationIdeas: {
                label: 'Administration des idées de publication',
                altLabel: 'Gérer les idées de publication.'
            },
            horseChestnut: {
                label: 'Marronnier',
                altLabel: 'Gérer les événements du marronnier.'
            },
            promotionCodes: {
                label: 'Codes de promotion',
                altLabel: 'Gérer les codes de promotion.'
            },
            bills: {
                label: 'Factures',
                altLabel: 'Consulter les factures des clients.'
            }
        },

        // Label spécifique pour les clients
        customer: {
            communityManager: {
                label: 'Community Manager',
            },
            editorialLine: {
                label: 'Ligne éditoriale'
            },
            contacts: {
                label: 'Utilisateurs',
                altLabel: 'Gérer les comptes de vos utilisateurs.'
            },
            statistics: {
                label: 'Statistiques',
                altLabel: 'Consulter les statistiques de vos réseaux sociaux.'
            },
            tasks: {
                submenu: {
                    label: 'Inspirations & Posts'
                },
                list: {
                    label: 'Liste des posts',
                },
                requestValidation: {
                    label: 'Validation des posts'
                },
                add: {
                    label: 'Ajouter des posts'
                },
                statistics: {
                    label: 'Statistiques'
                }
            },
            publicationsComments: {
                list: {
                    label: 'Commentaires',
                }
            },
            settings: {
                submenu: {
                    label: 'Paramètres'
                },
                editorialLine: {
                    label: 'Ligne éditoriale',
                },
                writingStyles: {
                    label: 'Style rédactionnel'
                },
                postsSettings: {
                    label: 'Personnalisation des posts'
                },
                visualIdentity: {
                    label: 'Identité visuelle'
                },
                graphicalTemplates: {
                    label: 'Modèles graphiques'
                },
                socialNetworks: {
                    label: 'Mes réseaux sociaux'
                }
            },
            administration: {
                submenu: {
                    label: 'Administration'
                },
                roles: {
                    label: 'Rôles',
                },
                contacts: {
                    label: 'Contacts'
                },
                notifications: {
                    label: 'Notifications'
                },
                repositoryFiles: {
                    label: 'Mon répertoire fichiers'
                }
            }
        },

        creditsAndSubscription: {
            submenu: {
                label: 'Crédits et Abonnements'
            },
        },

        administration: {
            submenu: {
                label: 'Administration'
            },
        },

        unsubscribeMessages: {
            label: 'Messages de désabonnement',
            altLabel: 'Gérer les messages et les statistiques de désabonnement.'
        },

        permissionRole: {
            submenu: {
                label: 'Permissions et Rôles'
            },
            permissions: {
                label: 'Gestion des permissions',
                altLabel: 'Gérer la liste des permissions.'
            },
            roles: {
                label: 'Gestions des rôles',
                altLabel: 'Gérer la liste des rôles de vos utilisateurs.'
            },
        },
        application: {
            label: 'Personnalisation de l\'application',
            altLabel: 'Gérer les CGU et la politique de confidentialité de l\'application'
        },
        mailsConfiguration: {
            label: 'Configuration des emails',
            altLabel: 'Gérer la configuration des emails internes.'
        },

        users: {
            submenu: {
                label: 'Utilisateurs'
            },
            internalAgent: {
                label: 'Gestion des agents internes',
                altLabel: 'Gérer la liste des agents internes à l\'entreprise.'
            },
            externalAgent: {
                label: 'Gestion des agents externes',
                altLabel: 'Gérer la liste des agents externes à l\'entreprise.'
            },
            teamManager: {
                label: 'Gestion des managers',
                altLabel: 'Gérer la liste des managers.'
            },
            productManager: {
                label: 'Gestion des chefs de produit',
                altLabel: 'Gérer la liste des chefs de produit.'
            },
            agencyManager: {
                label: 'Gestion des managers d\'agences',
                altLabel: 'Consulter la liste des managers d\'agences.'
            },
            customer: {
                label: 'Gestion des clients',
                altLabel: 'Gérer la liste des clients.'
            },

            requestedHolidays: {
                label: 'Demande de congés',
                altLabel: 'Consulter et répondre aux demandes de congés'
            },

            agencyCustomer: {
                item: {
                    altLabel: 'Consulter la liste des posts de { customer }.',
                    profileImage: {
                        altLabel: 'Image de profil de { customer }.'
                    }
                }
            }

        },

        contacts: {
            label: 'Gestion des contacts',
            altLabel: 'Gérer la liste des comptes contacts rattachés à votre compte.'
        },

        activitySectors: {
            label: 'Secteurs d\'activité',
            altLabel: 'Gérer la liste des secteurs d\'activité et leurs métiers.'
        },

        coachingOffers: {
            label: 'Offres de coaching',
            altLabel: 'Gérer les offres de coaching.'
        },

        logout: {
            label: 'Se déconnecter',
            altLabel: 'Se déconnecter de la plateforme'
        }
    },

    // Menu du header
    header: {
        account: {
            userAccount: {
                label: 'Mon compte',
                altLabel: 'Consulter les informations de votre compte.'
            },
            subscription: {
                label: 'Mon forfait',
                altLabel: 'Consulter le détail de votre abonnement.'
            },
            bills: {
                label: 'Mes factures',
                altLabel: 'Consulter vos factures.'
            },
            logout: {
                label: 'Déconnexion',
                altLabel: 'Se déconnecter de l\'application.'
            },
            agency: {
                users: {
                    label: 'Gestion des utilisateurs',
                    altLabel: 'Consulter la liste des utilisateurs de l\'agence.'
                }
            }
        },
        helpButton: {
            label: 'Aide'
        },
        trialPeriod: {
            remainingTime: 'restant avant la fin de votre période d\'essai | restant avant la fin de votre période d\'essai | restants avant la fin de votre période d\'essai'
        }
    },

    // Menu déroulant de sélection des profils des réseaux sociaux
    socialNetworks: {
        profiles: {
            dropdown: {
                label: 'Choix du compte'
            }
        }
    },



    agency: {
        customer: {
            // Menu de raccourcis pour la gestion d'un client d'une agence
            shortcutMenu: {
                tasksList: {
                    altLabel: 'Gérer les publications de { customer }.'
                },
                comments: {
                    altLabel: 'Gérer les commentaires de { customer }.'
                },
                statistics: {
                    altLabel: 'Consulter les statistiques de { customer }.'
                },
                postsSettings: {
                    altLabel: 'Gérer la personnalisation des posts de { customer }.'
                },
                visualIdentity: {
                    altLabel: 'Gérer l\'identité visuelle de { customer }.'
                },
                writingStyles: {
                    altLabel: 'Consulter le style rédactionnel de { customer }.'
                },
                graphicalLineTemplates: {
                    altLabel: 'Gestion des modèles graphiques de { customer }.'
                }
            }
        }
    }
};
